<script setup lang="ts">
  import { fmt } from '@/functions'
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    promos: SearchPromo[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: promo }"
    :items="promos"
    route-list="promo list"
    route-detail="promo detail"
    name="Promo">
    <div class="text-sm font-medium">
      {{ promo.title }}
    </div>
    <div class="mb-1 text-xs text-gray-600">
      {{ fmt.date(promo.started_at) }} - {{ fmt.date(promo.ended_at) }}
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-eye" />
      </div>
      <div>{{ promo.views }} dilihat</div>
    </div>
  </search-result-group>
</template>
